import { render, staticRenderFns } from "./text-row-proposal-specification-table.vue?vue&type=template&id=30e82b3d&"
import script from "./text-row-proposal-specification-table.vue?vue&type=script&lang=js&"
export * from "./text-row-proposal-specification-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30e82b3d')) {
      api.createRecord('30e82b3d', component.options)
    } else {
      api.reload('30e82b3d', component.options)
    }
    module.hot.accept("./text-row-proposal-specification-table.vue?vue&type=template&id=30e82b3d&", function () {
      api.rerender('30e82b3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/proposals/partials/text-row-proposal-specification-table.vue"
export default component.exports